import { render } from "./PauseIcon.vue?vue&type=template&id=15add18d"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/PauseIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15add18d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15add18d', __exports__)) {
    api.reload('15add18d', __exports__)
  }
  
  module.hot.accept("./PauseIcon.vue?vue&type=template&id=15add18d", () => {
    api.rerender('15add18d', render)
  })

}


export default __exports__